import React from "react";
import cns from "classnames";
import { withStyles } from "@material-ui/core";
import { Classes, ThemeType } from "@theme";
import { BaseIconButtonProps } from "@components/buttons/BaseIconButton";

type Props = BaseIconButtonProps & {
  classes?: Classes<typeof styles>;
  className?: string;
  type?: "filled" | "half" | "secondHalf";
};

export function RoundIcon(props: Props) {
  const { children, classes, className, type } = props;

  const _className = cns(className, classes.root, {
    [classes.filled]: type === "filled",
    [classes.half]: type === "half",
    [classes.secondHalf]: type === "secondHalf"
  });
  return (
    // <div className={_className} {...rest}> //TODO: MUI4 is this really necessary? ButtonProps are different from DivProps.
    <div className={_className}>{children}</div>
  );
}

const styles = (theme: ThemeType) => ({
  root: {
    display: "block",
    width: 20,
    height: 20,
    borderRadius: 50,
    border: "2px solid",
    borderColor: theme.palette.secondary.main,
    overflow: "hidden",
    position: "relative"
  },
  filled: {
    background: theme.palette.secondary.main
  },
  half: {
    position: "relative",
    "&::before": {
      content: `''`,
      width: "50%",
      background: theme.palette.secondary.main,
      left: 0,
      top: 0,
      height: "100%",
      position: "absolute"
    }
  },
  secondHalf: {
    position: "relative",
    "&::before": {
      content: `''`,
      width: "50%",
      background: theme.palette.secondary.main,
      right: 0,
      top: 0,
      height: "100%",
      position: "absolute"
    }
  }
});

export default withStyles(styles as any)(RoundIcon);
